import { domainMap } from "./domainMap"

const mapDomainInfo = () => {
  const domainInfo = domainMap.find(info =>
    window.location.href.includes(info.name))
    || domainMap.find(info => info.name === "default")
  const isDev = window.location.port
  const { merchantEmail, merchantCampaignUid } = domainInfo
  return {
    ...domainInfo,
    merchantEmail: isDev ?
      merchantEmail?.dev : merchantEmail?.prod || null,
    merchantCampaignUid: isDev ?
      merchantCampaignUid?.dev : merchantCampaignUid?.prod || null,
  }
}

export { mapDomainInfo }